import React from 'react'
import gql from 'graphql-tag'
import DeliveredUrl from 'components/shared/DeliveredUrl'
import DefaultProductStatus from '../../DefaultProductStatus'

const StylingProduct = ({product}) => {
  if (product.state === 'delivered') {
    return (
      <DeliveredUrl
        product={product}
        getDeliveredUrl={({assets}) => {
          const report = assets.edges.find(e => e.node.scope === 'output')
          return report && report.node.url
        }}
      />
    )
  }

  return (
    <DefaultProductStatus product={product} />
  )
}

StylingProduct.fragment = gql`
  fragment StylingProduct on StylingProduct {
    booking {id, startsAt, endsAt, resourceName}
    assets {
      edges {
        node {
          id
          state
          ...on DocumentAsset {url, scope}
        }
      }
    }
  }
`

export default StylingProduct
